var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.25C8.5733 3.25 7.41671 4.4066 7.41671 5.83333C7.41671 7.26007 8.5733 8.41667 10 8.41667C11.4268 8.41667 12.5834 7.26007 12.5834 5.83333C12.5834 4.4066 11.4268 3.25 10 3.25ZM5.91671 5.83333C5.91671 3.57817 7.74488 1.75 10 1.75C12.2552 1.75 14.0834 3.57817 14.0834 5.83333C14.0834 8.0885 12.2552 9.91667 10 9.91667C7.74488 9.91667 5.91671 8.0885 5.91671 5.83333ZM3.77935 12.946C4.54513 12.1802 5.58374 11.75 6.66671 11.75H13.3334C14.4163 11.75 15.455 12.1802 16.2207 12.946C16.9865 13.7118 17.4167 14.7504 17.4167 15.8333V17.5C17.4167 17.9142 17.0809 18.25 16.6667 18.25C16.2525 18.25 15.9167 17.9142 15.9167 17.5V15.8333C15.9167 15.1482 15.6445 14.4911 15.1601 14.0066C14.6756 13.5222 14.0185 13.25 13.3334 13.25H6.66671C5.98156 13.25 5.32448 13.5222 4.84001 14.0066C4.35555 14.4911 4.08337 15.1482 4.08337 15.8333V17.5C4.08337 17.9142 3.74759 18.25 3.33337 18.25C2.91916 18.25 2.58337 17.9142 2.58337 17.5V15.8333C2.58337 14.7504 3.01358 13.7118 3.77935 12.946Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "b9a2201b6f28312ea673a2a10c93fb9d.svg";
export { ForwardRef as ReactComponent };